import { ErrorConfig } from '@/helper/error';

const types = {
  ERROR_FRAGMENT_EMPTY: 'errorFragmentEmpty',
};

interface InitProps {
  errorIcon: any; //错误icon
  errorText?: string; //错误文案
  errorBtn?: string; //错误按钮名称
  key?: string; //Errorconfig中的key
}
interface ActionProps {
  type?: string;
  payload?: any;
}
// 设置默认值
const initState: InitProps = {
  errorIcon: '',
  errorText: '',
  errorBtn: '',
  key: 'netWorkError',
};

const errorReducer = (state = initState, action: ActionProps = {}) => {
  const { type, payload } = action;
  switch (type) {
    case types.ERROR_FRAGMENT_EMPTY:
      return {
        ...state,
        ...ErrorConfig[payload.key],
      };
    default:
      return {
        ...state,
        ...ErrorConfig.activeEnd,
      };
  }
};

export default errorReducer;

export const errorActions = {
  setFragmentEmptyError: function (payload: object) {
    return { type: types.ERROR_FRAGMENT_EMPTY, payload };
  },
};
